import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function enableFlag(body, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/p/enableupdateflag`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });

    return response;
}

export default function useEnableUpdateFlag() {
    const enableUpdateFlag = useAuthMutation({
        mutationFn: enableFlag,
        mutationKey: ['flight-update'],
        retry: 2,
        delay: 1000
    });

    return { enableUpdateFlag };
}
